import { render, staticRenderFns } from "./star.vue?vue&type=template&id=11f4c310&scoped=true&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&id=11f4c310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f4c310",
  null
  
)

component.options.__file = "star.vue"
export default component.exports